/* =======================================================================
   VisitPage — Pagina Contatti (indirizzo, orari, telefoni, mappa)
   =======================================================================
   Tutti i dati arrivano da src/data/copy.js → sezione "visit".
   ======================================================================= */
import copy from "@/data/copy";
import Visit from "@/components/site/Visit";

export default function VisitPage() {
  return (
    <div data-testid="page-visit" className="pt-24 lg:pt-32">
      <Visit copy={copy} />
    </div>
  );
}
